/**
 * SAT Progress - drives the scanning screen.
 *
 * The backend returns a single response with no intermediate progress, so the
 * bar is advanced on an estimated duration and then snapped to 100% when the
 * work actually finishes. Phases give the wait a sense of what is happening.
 */
(function (global) {
  "use strict";

  function Progress(els) {
    this.els = els;
    this.timer = null;
    this.phases = [];
    this.from = 0;
    this.to = 0;
    this.startedAt = 0;
    this.duration = 1;
  }

  Progress.prototype.render = function (pct) {
    var rounded = Math.round(pct);

    if (this.els.bar) this.els.bar.style.width = rounded + "%";
    if (this.els.pct) this.els.pct.textContent = rounded + "%";

    // Pick the phase whose threshold the bar has passed.
    var phase = null;
    for (var i = 0; i < this.phases.length; i++) {
      if (rounded >= this.phases[i].at) phase = this.phases[i];
    }
    if (phase) {
      if (this.els.label && this.els.label.textContent !== phase.label) {
        this.els.label.textContent = phase.label;
      }
      if (
        this.els.sub &&
        phase.sub !== undefined &&
        this.els.sub.textContent !== phase.sub
      ) {
        this.els.sub.textContent = phase.sub;
      }
    }
  };

  Progress.prototype.stop = function () {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  };

  /**
   * Creep from `from` to `to` over `duration` ms, easing out so it slows as it
   * approaches the ceiling rather than sitting still at it.
   */
  Progress.prototype.start = function (opts) {
    this.stop();

    this.phases = (opts.phases || []).slice().sort(function (a, b) {
      return a.at - b.at;
    });
    this.from = opts.from != null ? opts.from : 0;
    this.to = opts.to != null ? opts.to : 90;
    this.duration = Math.max(opts.duration || 8000, 1);
    this.startedAt = Date.now();

    this.render(this.from);

    var self = this;
    this.timer = setInterval(function () {
      var elapsed = Date.now() - self.startedAt;
      var t = Math.min(elapsed / self.duration, 1);
      var eased = 1 - Math.pow(1 - t, 2);
      self.render(self.from + (self.to - self.from) * eased);
      if (t >= 1) self.stop();
    }, 120);
  };

  /** Jump to 100% and settle on a closing message. */
  Progress.prototype.finish = function (label, sub) {
    this.stop();
    this.phases = [];
    if (this.els.label && label) this.els.label.textContent = label;
    if (this.els.sub) this.els.sub.textContent = sub || "";
    this.render(100);
  };

  /**
   * Stop advancing but leave the bar where it is, and set a closing message.
   * Used both when a step fails and when one page hands the bar to the next.
   */
  Progress.prototype.hold = function (label, sub) {
    this.stop();
    this.phases = [];
    if (this.els.label && label) this.els.label.textContent = label;
    if (this.els.sub) this.els.sub.textContent = sub || "";
  };

  /**
   * Like hold(), but drops the percentage: a number frozen wherever the run
   * happened to stop ("94%") reads as still-in-progress on a screen that has
   * just said it failed.
   */
  Progress.prototype.fail = function (label, sub) {
    this.hold(label, sub);
    if (this.els.pct) this.els.pct.textContent = "";
  };

  global.SATProgress = {
    create: function (els) {
      return new Progress(els);
    },
  };
})(window);
